import baseMessage from './baseMessage'

export const ES_CL = {
  message: {
    ...baseMessage,
    label: {
      dni: 'RUT',
      userHint: 'Se puede buscar por Nombres, Apellidos, Documento de identidad'
    },
    selfService: {
      fields: {
        state: 'Provincia',
        city: 'Comuna',
        department: 'Departamento',
        cbu: 'Número de cuenta'
      }
    }
  }
}
